import React from 'react';
import DialogBase from './DialogBase';


interface DialogStopSharingOrganisatieProps {
  open: boolean;
  title: string;
  contentText?: string;
  onClose: () => void;
  onStopSharing: () => void;
}

const DialogStopSharingOrganisatie: React.FC<DialogStopSharingOrganisatieProps> = ({
  open,
  title,
  contentText,
  onClose,
  onStopSharing
}) => {

  return (
    <DialogBase
      open={open}
      title={title}
      contentText={contentText}
      confirmButtonText="Stoppen"
      onClose={onClose}
      onConfirm={onStopSharing}
    >
    </DialogBase>
  );
};

export default DialogStopSharingOrganisatie;
